export function mapLocale(locale: string): string {
  const DEFAULT_LOCALE = 'en-US';
  if (/en\b/.test(locale)) return DEFAULT_LOCALE;
  else if (/fr\b/.test(locale)) return 'fr-CA';
  else if (/es-MX\b/.test(locale)) return 'es-MX';
  else return DEFAULT_LOCALE;
}
